import React from 'react';
import { useRouter } from 'next/router';
import { Box } from '@qga/roo-ui/components';
import { isAfter, isBefore } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import PropTypes from 'prop-types';

import Header from '@/components/Header';
import MaintenanceView from '@/components/MaintenanceView';
import SiteFooter from '@/v2/components/ui/SiteFooter';
import SiteMessage from '@/v2/components/ui/SiteMessage';
import { useAppSettings } from '../AppSettingsProvider';
import PageHeader from '../PageHeader';

//This component will be removed after fully moving the app to v2
export const Layout = ({ children }) => {
  const { maintenanceMessage, campaignMessage } = useAppSettings();

  const router = useRouter();
  const isContactUsPage = router.asPath.includes('contact-us');

  let showMaintenanceMessage = false;
  if (maintenanceMessage?.enabled) {
    const { start, end } = maintenanceMessage;
    const now = zonedTimeToUtc(new Date(), start.timezone);
    showMaintenanceMessage =
      isAfter(now, zonedTimeToUtc(start.utc, start.timezone)) &&
      (!end || isBefore(now, zonedTimeToUtc(end.utc, end.timezone))) &&
      !isContactUsPage;
  }

  return (
    <Box bg="greys.porcelain">
      <Header />
      <PageHeader />
      <SiteMessage siteMessage={campaignMessage} variant="info" />
      {showMaintenanceMessage ? (
        <MaintenanceView maintenanceMessage={maintenanceMessage} />
      ) : (
        children
      )}
      <SiteFooter />
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
